import { render, staticRenderFns } from "./FilterTagList.vue?vue&type=template&id=97c018fe&scoped=true"
import script from "./filterTagList.ts?vue&type=script&lang=ts&external"
export * from "./filterTagList.ts?vue&type=script&lang=ts&external"
import style0 from "./FilterTagList.vue?vue&type=style&index=0&id=97c018fe&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "97c018fe",
  null
  
)

export default component.exports